<section class="main-content">
  <markdown class="page-markdown" [data]="'homePage.spirit.content' | translate"></markdown>
</section>
